import styled from 'styled-components'
import arrowDown from '../../../../../assets/certificates/AddCertificate/arrow-down.svg'

export const Container = styled.div`
  background-color: #fff;
  width: 19rem;
  height: fit-content;
  padding-bottom: 0.7rem;
  margin-top: 0.6rem;
  margin-left: 1.32rem;
  border-radius: 0.7rem;
  align-items: center;

   @media (max-width: 1920px) {
        width: 14rem;
    }

    @media (max-width: 960px) {
        width: 11.5rem;
    }

    @media (max-width: 720px) {
        width: 9rem;
    }

    @media (max-width: 480px) {
        width: 8rem;
    }
`

export const HeaderDiv = styled.div`
  display: flex;
  margin-top: 0.4rem;
  margin-left: 0.5rem;
  align-items: center;
  cursor: pointer;
`

export const HeaderText = styled.h3`
  margin-left: 0.62rem;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: clamp(0.7rem, calc(0.7rem + 0.1vw) , 1.5rem);
`

export const InputDiv = styled.div`
    margin-left: 0.92rem;
    margin-top: 0.7rem;
    position: relative;

    .empty {
        border: 0;
    }
`

export const InputLabel = styled.label`
    display: block;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: clamp(0.7rem, calc(0.7rem + 0.1vw) , 1.5rem);
`

export const StyledSelect = styled.select`
    background-color: #ebebeb;
    color: #777777;
    height: 2.2rem;
    width: 14rem;
     font-size: clamp(0.6rem, calc(0.6rem + 0.1vw) , 1.3rem);
    margin-top: 0.45rem;
    padding-left: 0.92rem;
    padding-right: 2.15rem;
    border-radius: 1.78rem;
    border: 1px solid #e1e1e1;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${arrowDown});
    background-repeat: no-repeat;
    background-position-x: 10.1rem;
    background-position-y: 0.7rem;
    background-size: 1.2rem;

    :focus{
        outline: 0;
    }

    @media (max-width: 1920px) {
        width: 12.2rem;
    }

    @media (max-width: 960px) {
        width: 9.8rem;
    }

    @media (max-width: 720px) {
        width: 7.2rem;
    }

    @media (max-width: 480px) {
        width: 6rem;
    }
`

export const StyledOption = styled.option`
    background-color: #fff;
    height: 0.7rem;
    font-size: clamp(0.5rem, calc(0.6rem + 0.1vw) , 1.3rem);
`